import type { AuthOptions } from './types/auth.types';
import { getAppAuth } from './window.utils';

export const getToken = async (authOptions?: AuthOptions): Promise<string> => {
    const appAuth = getAppAuth();
    if (!appAuth) {
        return '';
    }

    const token = authOptions?.msalToken
        ? await appAuth.getMsalToken()
        : authOptions?.getUserV2
          ? await appAuth.getUserV2()
          : await appAuth.getUser();
    return 'accessToken' in token ? token.accessToken : '';
};
